import React from 'react';
import { Link } from 'react-router-dom';
import { createPortal } from 'react-dom';

import './Sidebar.scss';
import LoginButton from './LoginButton';
import UserRoleProtected from './UserRoleProtected';
import { Clearance } from '../data/sessionSlice';

type SidebarProps = {
  open: boolean;
  onClose: () => void;
};

class Sidebar extends React.Component<SidebarProps> {
  state = {
    showLogin: false,
  };

  render() {
    const root = document.getElementById('portal-root');
    const maybeOpenClassName = this.props.open ? ' open' : '';

    return createPortal(
      <>
        <nav className={'sidebar' + maybeOpenClassName}>
          <Link className="link" onClick={this.props.onClose} to="/">
            Who Is NemO'S
          </Link>
          <Link className="link" onClick={this.props.onClose} to="/walls">
            Walls
          </Link>
          <Link className="link" onClick={this.props.onClose} to="/drawings">
            Drawings
          </Link>
          <Link className="link" onClick={this.props.onClose} to="/sketches">
            Sketches
          </Link>
          <UserRoleProtected protectedStyle="unlaunched" clearance={Clearance.ComingSoon}>
            <Link className="link" onClick={this.props.onClose} to="/tattoos">
              Tattoos
            </Link>
            <Link className="link" onClick={this.props.onClose} to="/projects">
              Projects
            </Link>
            <Link className="link" onClick={this.props.onClose} to="/others">
              Others
            </Link>
          </UserRoleProtected>
          <Link className="link" onClick={this.props.onClose} to="/press">
            Press
          </Link>
          <a
            className="link"
            onClick={this.props.onClose}
            href="https://nemoshop.bigcartel.com/"
            target="_blank"
          >
            Shop
          </a>
          <div className="footnotes">
            <span>
              Website by{' '}
              <a href="http://www.djjeck.com" target="_blank" rel="noopener noreferrer">
                djjeck
              </a>
            </span>{' '}
            • <LoginButton />
          </div>
        </nav>
        <div className={'sidebar-overlay' + maybeOpenClassName} onClick={this.props.onClose}></div>
      </>,
      root
    );
  }
}

export default Sidebar;
